// Divider.js
import React from "react";
import { Row, Col } from "react-bootstrap";
import styles from './Divider.module.css'; // Import the CSS module properly

const Divider = ({ text }) => {
  return (
    <section className="infoOffer-section">
      <Row className="my-5">
        <Col>
          <div className={styles["mg-divider"]}>
            <span className={styles["divider-text-mg"]}> 
              <b>{text}</b>
            </span>
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default Divider;
